var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _vm.isTab2
      ? _c("div", [
          _c(
            "div",
            {
              staticClass: "result__card",
              class: {
                "is-tab2": _vm.isTab2,
              },
            },
            [
              _c("div", { staticClass: "result__card-wrapper" }, [
                _c(
                  "a",
                  {
                    staticClass: "profile-link utility-no-text-decoration",
                    attrs: { href: "/find-a-therapist/" + _vm.supplierPage },
                  },
                  [
                    _c("h4", [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.supplierName) +
                          "\n            "
                      ),
                      _vm._m(0),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "result__card-content-wrapper" }, [
                  _vm.supplierRegions
                    ? _c("div", { staticClass: "result__card-content-item" }, [
                        _c("p", { staticClass: "p-label result__card-label" }, [
                          _vm._v("Regions:"),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "result__description-wrapper" },
                          [
                            _c("p", [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.supplierRegions) +
                                  "\n              "
                              ),
                            ]),
                          ]
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "result__contact-details-wrapper" },
                    [
                      _vm.supplierPhoneNumber
                        ? _c("div", { staticClass: "result__contact-method" }, [
                            _c("div", {
                              staticClass: "icon icon-phone icon-phone-blue",
                            }),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                attrs: {
                                  "aria-label":
                                    "Phone number" + _vm.supplierPhoneNumber,
                                  href: "tel:" + _vm.supplierPhoneNumber,
                                },
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.supplierPhoneNumber) +
                                    "\n              "
                                ),
                              ]
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.supplierEmailAddress
                        ? _c("div", { staticClass: "result__contact-method" }, [
                            _c("div", {
                              staticClass: "icon icon-email icon-email-blue",
                            }),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                attrs: {
                                  "aria-label":
                                    "Email address $SupplierContactEmail",
                                  href: "mailto:" + _vm.supplierEmailAddress,
                                },
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.supplierEmailAddress) +
                                    "\n              "
                                ),
                              ]
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.supplierWebsite
                        ? _c("div", { staticClass: "result__contact-method" }, [
                            _c("div", {
                              staticClass:
                                "icon icon-website icon-website-blue",
                            }),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                attrs: {
                                  "aria-label":
                                    "Website address: " +
                                    _vm.supplierWebsiteText,
                                  href: _vm.supplierWebsite,
                                },
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.supplierWebsiteText) +
                                    "\n              "
                                ),
                              ]
                            ),
                          ])
                        : _vm._e(),
                    ]
                  ),
                ]),
              ]),
            ]
          ),
        ])
      : _c("div", [
          _c(
            "div",
            {
              staticClass: "result__card",
              class: {
                "is-tab2": _vm.isTab2,
              },
            },
            [
              _vm.providerId
                ? _c("div", [
                    _c(
                      "a",
                      {
                        attrs: { href: "/find-a-therapist/" + _vm.providerId },
                      },
                      [
                        _c("div", { staticClass: "result__card-wrapper" }, [
                          _c("h4", [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.firstName) +
                                " " +
                                _vm._s(_vm.surname) +
                                "\n              "
                            ),
                            _vm._m(1),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "result__card-content-wrapper" },
                            [
                              _c(
                                "div",
                                { staticClass: "result__card-content-item" },
                                [
                                  _c(
                                    "p",
                                    {
                                      staticClass: "p-label result__card-label",
                                    },
                                    [_vm._v("Regions:")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "result__description-wrapper",
                                    },
                                    [
                                      _vm.regions
                                        ? _c("p", [_vm._v(_vm._s(_vm.regions))])
                                        : _c("p", [_vm._v("Not specified")]),
                                    ]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "result__card-content-item" },
                                [
                                  _c(
                                    "p",
                                    {
                                      staticClass: "p-label result__card-label",
                                    },
                                    [_vm._v("Gender:")]
                                  ),
                                  _vm._v(" "),
                                  _vm.gender
                                    ? _c("p", [_vm._v(_vm._s(_vm.gender))])
                                    : _c("p", [_vm._v("Not specified")]),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "result__card-content-item" },
                                [
                                  _c(
                                    "p",
                                    {
                                      staticClass: "p-label result__card-label",
                                    },
                                    [_vm._v("Spoken languages:")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "result__description-wrapper",
                                    },
                                    [
                                      _vm.languages
                                        ? _c("p", [
                                            _vm._v(_vm._s(_vm.languages)),
                                          ])
                                        : _c("p", [_vm._v("Not specified")]),
                                    ]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "result__card-content-item" },
                                [
                                  _c(
                                    "p",
                                    {
                                      staticClass: "p-label result__card-label",
                                    },
                                    [_vm._v("Cultural expertise:")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "result__description-wrapper",
                                    },
                                    [
                                      _vm.culturalExperience
                                        ? _c("p", [
                                            _vm._v(
                                              _vm._s(_vm.culturalExperience)
                                            ),
                                          ])
                                        : _c("p", [_vm._v("Not specified")]),
                                    ]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "result__card-content-item" },
                                [
                                  _c(
                                    "p",
                                    {
                                      staticClass: "p-label result__card-label",
                                    },
                                    [_vm._v("Therapist expertise:")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "result__description-wrapper",
                                    },
                                    [
                                      _vm.therapistExperience
                                        ? _c("p", [
                                            _vm._v(
                                              _vm._s(_vm.therapistExperience)
                                            ),
                                          ])
                                        : _c("p", [_vm._v("Not specified")]),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]),
                      ]
                    ),
                  ])
                : _c("div", [
                    _c("div", { staticClass: "result__card-wrapper" }, [
                      _c("h4", [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.firstName) +
                            " " +
                            _vm._s(_vm.surname) +
                            "\n          "
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "result__card-content-wrapper" },
                        [
                          _c(
                            "div",
                            { staticClass: "result__card-content-item" },
                            [
                              _c(
                                "p",
                                { staticClass: "p-label result__card-label" },
                                [_vm._v("Regions:")]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "result__description-wrapper" },
                                [
                                  _vm.regions
                                    ? _c("p", [_vm._v(_vm._s(_vm.regions))])
                                    : _c("p", [_vm._v("Not specified")]),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "result__card-content-item" },
                            [
                              _c(
                                "p",
                                { staticClass: "p-label result__card-label" },
                                [_vm._v("Gender:")]
                              ),
                              _vm._v(" "),
                              _vm.gender
                                ? _c("p", [_vm._v(_vm._s(_vm.gender))])
                                : _c("p", [_vm._v("Not specified")]),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "result__card-content-item" },
                            [
                              _c(
                                "p",
                                { staticClass: "p-label result__card-label" },
                                [_vm._v("Spoken languages:")]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "result__description-wrapper" },
                                [
                                  _vm.languages
                                    ? _c("p", [_vm._v(_vm._s(_vm.languages))])
                                    : _c("p", [_vm._v("Not specified")]),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "result__card-content-item" },
                            [
                              _c(
                                "p",
                                { staticClass: "p-label result__card-label" },
                                [_vm._v("Cultural expertise:")]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "result__description-wrapper" },
                                [
                                  _vm.culturalExperience
                                    ? _c("p", [
                                        _vm._v(_vm._s(_vm.culturalExperience)),
                                      ])
                                    : _c("p", [_vm._v("Not specified")]),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "result__card-content-item" },
                            [
                              _c(
                                "p",
                                { staticClass: "p-label result__card-label" },
                                [_vm._v("Therapist expertise:")]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "result__description-wrapper" },
                                [
                                  _vm.therapistExperience
                                    ? _c("p", [
                                        _vm._v(_vm._s(_vm.therapistExperience)),
                                      ])
                                    : _c("p", [_vm._v("Not specified")]),
                                ]
                              ),
                            ]
                          ),
                        ]
                      ),
                    ]),
                  ]),
            ]
          ),
        ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "result__card-arrow" }, [
      _c("div", { staticClass: "icon icon-arrow-right-blue" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "result__card-arrow" }, [
      _c("div", { staticClass: "icon icon-arrow-right" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }